import { defineComponent as _defineComponent } from 'vue'
import { AbCatalogSection } from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { TextAlign } from '../../../../types';

interface Product {
  customLink?: string | null;
  description?: string | null;
  priceText?: string | null;
  image?: {
    src?: string | null;
    alt?: string | null;
  };
  name?: string | null;
  sku?: string | null;
  price?: string | null;
  disableClick?: boolean | null;
}

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  hideSku?: boolean | null;
  hidePrice?: boolean | null;
  items?: Product[];
  spacing?: Spacing | null;
  textAlign?: TextAlign | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogSectionSimple',
  props: {
    id: null,
    title: null,
    description: null,
    hideSku: { type: [Boolean, null] },
    hidePrice: { type: [Boolean, null] },
    items: null,
    spacing: null,
    textAlign: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  hideSku?: boolean | null;
  hidePrice?: boolean | null;
  items?: Product[];
  spacing?: Spacing | null;
  textAlign?: TextAlign | null;
};



return { __sfc: true,props, AbCatalogSection }
}

})